import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import moment from 'moment';

import { deleteCrmCustomFilter } from 'crm/contacts/_redux';
import {
  getCRMFiltersList,
  createCRMCustomFilter,
  setModifiedFastFilters,
  setCRMCustomFilter,
  setSelectedFastFilters,
} from 'crm/_redux/actions';
import queryString from 'query-string';

import {
  AddContact,
  BasicCRMModal,
  CustomFilterSelect,
  CRMModals,
  BaseButton,
  BaseStaticSelect,
  GetClientButton,
  SearchBar,
} from 'crm/_components';

import { FilterCreate, FilterChoose } from 'crm/_newComponents';

import TradingDateRangeField from 'common/components/form-fields/TradingDateRangeField/TradingDateRangeField';
import chooseFilter from './images/chooseFilter.svg';

import { staticStyles } from './style';

const ActionsTab = ({ areThereAnySelectedContacts, intl, history, location }) => {
  const [crmModalType, setCrmModalType] = useState(null);
  const [addContact, setAddContact] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isChooseOpen, setIsChooseOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const initialFilter = { value: '', label: intl.formatMessage({ id: 'crmCustomFilter' }) };
  const [filter, setFilter] = useState(initialFilter);
  const [filterId, setFilterId] = useState(null);
  const defaultTradingDate = `2025-01-01_${moment().format('YYYY-MM-DD')}`;
  const [tradingDate, setTradingDate] = useState(defaultTradingDate);

  // 初始化时检查 URL 参数，同步 trading_date 到 state、URL 和 sessionStorage
  useEffect(() => {
    const currentQuery = queryString.parse(location.search);

    // 如果没有 trading_date，添加默认值
    if (!currentQuery.trading_date) {
      // 以当前 URL 参数为准，只添加 trading_date，不保留 sessionStorage 中的旧参数
      const search = queryString.stringify({
        ...currentQuery,
        trading_date: defaultTradingDate,
      });
      sessionStorage.setItem('fastFiltersQuery', search);
      if (location.search !== `?${search}`) {
        history.replace({ search });
      }
      setTradingDate(defaultTradingDate);
    } else {
      // 如果 URL 中已有 trading_date，同步到 state 并更新 sessionStorage
      setTradingDate(currentQuery.trading_date);
      sessionStorage.setItem('fastFiltersQuery', location.search.substring(1));
    }
  }, [location.search, history]);
  const dispatch = useDispatch();
  const fastFilters = useSelector(state => state.crm.common.fastFilters);

  useEffect(() => {
    setFilterId(queryString.parse(location.search).filterId);
  }, [location.search]);

  const toggleModal = () => {
    setIsOpen(isOpen => !isOpen);
  };

  const handleResetFilter = () => {
    setFilter(initialFilter);
    setTradingDate(defaultTradingDate);
    dispatch(setModifiedFastFilters({}));
    dispatch(setCRMCustomFilter({}));
    dispatch(setSelectedFastFilters({ ...fastFilters }));

    sessionStorage.clear('fastFiltersQuery');

    history.replace('/crm/contacts/');
  };

  const toggleChooseModal = () => {
    if (filterId) handleResetFilter();

    setIsChooseOpen(!isChooseOpen);
  };
  const toggleDeleteModal = id => {
    setDeleteId(id);
    setIsDeleteOpen(isEditOpen => !isEditOpen);
  };
  const deleteCustomFilter = id => {
    deleteCrmCustomFilter(id, dispatch);
  };

  const handleFilterChange = value => {
    if (value.value === 'create') {
      toggleModal();
    } else {
      setFilter(value);

      const currentQuery = queryString.parse(location.search);
      // 移除 page_size 参数，重置页码到第一页
      const { page_size: pageSize, page: currentPage, ...restQuery } = currentQuery;
      const search = queryString.stringify({
        ...restQuery,
        page: 1,
        page_size: 10,
        filterId: value.value,
      });

      sessionStorage.setItem('fastFiltersQuery', search);

      history.replace({
        search,
      });
    }
  };

  const handleSearchChange = searchValue => {
    const currentQuery = queryString.parse(location.search);
    // 移除 page_size 参数，重置页码到第一页
    const { page_size: pageSize, page: currentPage, ...restQuery } = currentQuery;
    const search = queryString.stringify({
      ...restQuery,
      page: 1,
      page_size: 10,
      search: searchValue,
    });

    sessionStorage.setItem('fastFiltersQuery', search);

    history.replace({
      search,
    });
  };

  const handleTradingDateChange = dateRange => {
    setTradingDate(dateRange);
    const currentQuery = queryString.parse(location.search);
    // 移除 page_size 参数，重置页码到第一页
    const { page_size: pageSize, page: currentPage, ...restQuery } = currentQuery;
    const search = queryString.stringify({
      ...restQuery,
      page: 1,
      page_size: 10,
      trading_date: dateRange || undefined,
    });

    sessionStorage.setItem('fastFiltersQuery', search);

    history.replace({
      search,
    });
  };

  const actionOptions = [
    {
      label: intl.formatMessage({ id: 'justReassign' }),
      value: 'reassign',
    },
    {
      label: intl.formatMessage({ id: 'reassignManager' }),
      value: 'reassignManager',
    },
    {
      label: intl.formatMessage({ id: 'setPartnerCode' }),
      value: 'setPartnerCode',
    },
    {
      label: intl.formatMessage({ id: 'saveAs' }),
      value: 'saveAs',
    },
  ];

  return (
    <div className="ActionsTab">
      <div className="ActionsTab__filters-left">
        <div className="ActionsTab__actions-wrapper">
          <BaseStaticSelect
            labelTextId="justActions"
            options={actionOptions}
            onSelect={value => {
              setCrmModalType(value);
            }}
            isDisabled={!areThereAnySelectedContacts}
          />
          <MediaQuery query="(max-width: 479px)">
            <button className="ActionsTab__filter-choose" onClick={toggleChooseModal}>
              <img src={chooseFilter} alt="choose filter" />
            </button>
          </MediaQuery>
        </div>
        <div className="ActionsTab__search-wrapper">
          <SearchBar onChange={handleSearchChange} />
        </div>
        <div className="ActionsTab__trading-date">
          <TradingDateRangeField value={tradingDate} onChange={handleTradingDateChange} />
        </div>
        <MediaQuery query="(min-width: 479px)">
          <button className="ActionsTab__filter-choose" onClick={toggleChooseModal}>
            <img src={chooseFilter} alt="choose filter" />
          </button>
        </MediaQuery>
      </div>
      <div className="ActionsTab__filters-right">
        <div className="ActionsTab__filter-row-mobile">
          <div className="ActionsTab__filter-select">
            <CustomFilterSelect
              getFilters={getCRMFiltersList}
              filtersSelector={state => state.crm.common.filtersList}
              modifiedFiltersSelector={state => state.crm.common.modifiedFilters}
              onChange={handleFilterChange}
              toggleDeleteModal={toggleDeleteModal}
              onResetFilter={handleResetFilter}
              filter={filter}
              filterId={filterId}
            />
          </div>
          {/* Get a client 按钮：仅移动端显示，与 Custom filter 同行右对齐 */}
          <MediaQuery query="(max-width: 479px)">
            <div className="ActionsTab__get-client-mobile">
              <GetClientButton />
            </div>
          </MediaQuery>
        </div>
        <div className="ActionsTab__contacts">
          <BaseButton textId="justUploadContacts" onClick={() => setAddContact(true)} plus />
        </div>
      </div>
      <AddContact isOpen={addContact} onRequestClose={() => setAddContact(false)} />
      {crmModalType && <CRMModals modalType={crmModalType} onRequestClose={() => setCrmModalType(null)} />}
      <BasicCRMModal isOpen={isOpen} captionId="crmCustomFilter" onRequestClose={toggleModal}>
        <FilterCreate
          onRequestClose={toggleModal}
          modifiedFiltersSelector={state => state.crm.common.modifiedFilters}
          createCustomFilterSubmitFunc={createCRMCustomFilter}
        />
      </BasicCRMModal>
      <BasicCRMModal
        isOpen={isChooseOpen}
        onRequestClose={toggleChooseModal}
        captionId="crmChooseFiltersToDisplay"
        className="FilterChooseModal">
        <FilterChoose
          modifiedFiltersSelector={state => state.crm.common.modifiedFilters}
          onRequestClose={toggleChooseModal}
          setCustomFilter={setFilter}
        />
      </BasicCRMModal>
      <BasicCRMModal isOpen={isDeleteOpen} captionId="confirmText" onRequestClose={toggleDeleteModal}>
        <div className="ActionsTab__ModalButtons">
          <BaseButton
            color="white"
            textId="justCancel"
            onClick={() => {
              setIsDeleteOpen(false);
            }}
          />
          <BaseButton
            color="red"
            textId="justDelete"
            onClick={() => {
              deleteCustomFilter(deleteId);
              setIsDeleteOpen(false);
              if (+filterId === +deleteId) {
                handleResetFilter();
              }
            }}
          />
        </div>
      </BasicCRMModal>
      <style jsx>{staticStyles}</style>
    </div>
  );
};

export default compose(
  withRouter,
  injectIntl,
  connect(state => ({
    areThereAnySelectedContacts: !!state.crm.contacts.selectedContactsIds.length,
  }))
)(ActionsTab);
